import SEO from '../components/SEO';

const copyrightSections = [
  {
    title: "Content Ownership",
    items: [
      "All copy, imagery, branding, and design elements on letsfaceit.studio are owned by Let's Face It or used with permission.",
      "You may not reproduce, distribute, or repurpose any content without written approval.",
    ],
  },
  {
    title: "Portfolio Use",
    items: [
      "Work created during your session may appear in our portfolio, social channels, or marketing materials unless you request otherwise in writing.",
      "If anonymity matters, tell us before the booking so we can exclude your imagery from public use.",
    ],
  },
  {
    title: "Client Materials",
    items: [
      "Any mood boards, shot lists, or references you share remain your property.",
      "We use them solely to deliver the services outlined in your booking agreement.",
    ],
  },
];

export default function Copyright() {
  return (
    <section className="fixed top-0 left-0 h-full w-full overflow-y-auto bg-gradient-to-b from-[#f1ede7] via-[#ece6de] to-[#e4ded4] text-[#161616] mt-[70px] md:mt-[100px] pb-20 md:pb-32 lg:pb-36">
      <SEO
        title="Terms & Copyright"
        description="Terms of use and copyright policy for Let's Face It Studio. Learn how we handle content ownership, portfolio use, and client materials."
        canonical="https://letsfaceitcosmetics.com/terms"
      />
      <div className="mx-auto max-w-3xl px-4 py-11 xsm:py-[58px] sm:py-[85px] sm:px-8">
        <header className="space-y-4 text-center">
          <span className="text-xs uppercase tracking-[0.4em] text-[#5b5141]">Copyright Notice</span>
          <h1 className="font-mak text-4xl leading-tight text-[#1b1b1b] sm:text-5xl mt-4">
            Respect the craft and the credit.
          </h1>
          <p className="text-[18px] leading-relaxed text-[#3c3c3c] sm:text-xl">
            Everything we create belongs to Let's Face It unless otherwise agreed. Here's how we handle ownership and usage rights.
          </p>
        </header>

        <div className="mt-10 space-y-10">
          {copyrightSections.map((section) => (
            <article key={section.title} className="space-y-3">
              <h2 className="text-sm font-semibold uppercase tracking-[0.3em] text-[#5b5141]">
                {section.title}
              </h2>
              <ul className="list-disc space-y-2 pl-5 text-base leading-relaxed text-[#3c3c3c]">
                {section.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <footer className="mt-12 border-t border-[#d9cbb8] pt-6 text-left text-sm text-[#3c3c3c] sm:text-base">
          Questions about usage rights? Email{" "}
          <a href="mailto:hello@letsfaceitcosmetics.com" className="underline decoration-[#cbbda9] decoration-2 underline-offset-4">
            hello@letsfaceitcosmetics.com
          </a>{" "}
          and we'll clarify within one business day.
        </footer>
      </div>
    </section>
  );
}